
import { getWrappedFloatingBannerContainer } from '@bingads-webui-react/notification-center';
import { MiniCalloutWrapper } from './mini-callout';

export const WrappedFloatingBannerContainer = getWrappedFloatingBannerContainer(MiniCalloutWrapper);
